import { z } from 'zod';

export const EdgeSchema = z.enum(['top', 'bottom', 'left', 'right']);
